<!--Recherche par désignation--------------------------------------------------------------------------------------------------------------------------------------------------------->						

<template>
    <v-container grid-list-md text-center v-if="$store.state.VueRechercheDesignation">
        <v-layout wrap>
            <v-flex	xs12>
                <v-card color="grey lighten-5" height="auto">
                    <v-card-title>
                        <v-flex xs1 sm1 class="text-left">
                            <div class="text-center">
                                <v-dialog v-model="designationDialog" width="1000">
                                    <template v-slot:activator="{ on, info }">
                                        <v-btn icon color="blue" v-on="on" v-bind="info">
                                            <i class="fas fa-info-circle"></i>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title class="headline grey lighten-2" primary-title>
                                            Recherche par désignation
                                        </v-card-title>
                                        <v-card-text>
                                            {{ logLibelle }} : 
                                            {{ logMarque }}

                                            <h3 class="mt-3">Différents opérateurs peuvent être utilisés (voir ci-dessous) - Exemples : </h3> (afficher la page originale en français pour les utiliser)
                                            <p translate="no" class="blue--text">+10G -cordon* +noyau* +jaune</p>
                                            <p translate="no" class="blue--text">+bandeau +""9 prises"" +UTE -détrompée*</p>
                                            <v-card-text align="left">
                                                <v-data-table
                                                    :headers="InfoDesignationHeaders"
                                                    :items="this.$store.state.infoDesignation"
                                                    disable-filtering
                                                    disable-sort
                                                    hide-default-footer
                                                    color="blue lighten-2" 
                                                ></v-data-table>
                                            </v-card-text>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" text @click="designationDialog = false">
                                                Fermer
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </v-flex>
                        <v-flex xs10 sm10 class="text-left">
                            <h3>Recherche par désignation article</h3><small> en français uniquement (liste de prix FR) !</small>
                        </v-flex>
                        <v-flex xs1 sm1>
                            <v-btn text @click="rechercheMenu" class="text-right">X</v-btn>
                        </v-flex>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md text-center>
                            <v-layout wrap>
                                <v-flex xs12 sm4 class="text-left">
                                    <v-text-field 
                                        v-on:keyup.enter="loadDesignationArticle($store.state.libelle, $store.state.marque)"
                                        v-model="$store.state.libelle" label="Désignation article"
                                        filled
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm3 class="text-left">
                                    <v-select :multiple=true v-model="$store.state.marque" label="Filtrer par marques" :items="this.$store.state.marques" filled
                                        v-on:change="loadDesignationArticle($store.state.libelle, $store.state.marque)">
                                    </v-select>
                                </v-flex>
                                <v-flex xs2 sm1>
                                    <v-btn v-if="$store.state.libelle!=''" class="ma-2 d-flex align-center" color="blue"
                                        @click="loadDesignationArticle($store.state.libelle, $store.state.marque)" dark>
                                        <v-icon center>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12 sm4 v-if="$store.state.designationSelectedArticle != null">
                                    <v-card>
                                        <v-img 
                                            v-bind:src="$store.state.designationSelectedArticle[0].PHOTO_URL" 
                                            max-height="150"
                                            contain
                                            class="white"
                                            >
                                        </v-img>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 v-if="$store.state.libelle!='' && $store.state.libelle!=null && $store.state.dataDesignation[0] != 0">
                                    <v-card color="blue darken-2" class="white--text" height="auto">
                                        <v-card-title>
                                            <h5 v-if="$store.state.designationSelectedArticle != null">Article : {{ $store.state.designationSelectedArticle[0].EDI_Code }}
                                                <v-btn class="ma-3" color="blue" v-if="$store.state.designationSelectedArticle[0].FT_URL != ''" 
                                                @click="designationFt($store.state.designationSelectedArticle[0].FT_URL)" dark align="right">Fiche technique
                                                    <v-icon dark right>mdi-file-pdf</v-icon>
                                                </v-btn>
                                            </h5>

                                            <v-dialog v-if="$store.state.designationSelectedArticle != null" v-model="$store.state.stockDialog" width="500">
                                                <template v-slot:activator="{ on, stock }">
                                                    <v-btn class="ma-3"  v-on="on" v-bind="stock" @click="loadStockConectis($store.state.designationSelectedArticle[0].EDI_Code)" color="black" dark align="left">Stock Conectis 
                                                        <i class="fas fa-industry"></i>
                                                    </v-btn>
                                                </template>

                                                <v-card align="center">
                                                    <v-card-title class="headline grey lighten-2" primary-title>
                                                        Stock CONECTIS :
                                                    </v-card-title>
                                                    <v-flex v-if="$store.state.stockConectis_is_loading">
                                                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                                                        <h3 class="ma-10">
                                                            Connexion en cours...
                                                        </h3>
                                                    </v-flex>
                                                    <v-card-text>
                                                        <h3 class="ma-10" v-if="(this.$store.state.designationSelectedArticle[0].EDI_Code === $store.state.stockConectis.REFERENCE_ASW || this.$store.state.designationSelectedArticle[0].EDI_Code === $store.state.stockConectis.REFERENCE_CONECTIS) && $store.state.stockConectis.QUANTITE >= 0">
                                                            {{ $store.state.stockConectis.QUANTITE }} unité(s)
                                                        </h3>
                                                        <h3 class="ma-10" v-if="!(((this.$store.state.designationSelectedArticle[0].EDI_Code === $store.state.stockConectis.REFERENCE_ASW || this.$store.state.designationSelectedArticle[0].EDI_Code === $store.state.stockConectis.REFERENCE_CONECTIS) && $store.state.stockConectis.QUANTITE >= 0) || $store.state.stockConectis_is_loading)">
                                                            Indisponible
                                                        </h3>
                                                    </v-card-text>
                                                    <v-divider></v-divider>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="primary" text @click="$store.state.stockDialog = false">
                                                            Fermer
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>

                                        </v-card-title>
                                        <v-card-text align="left" v-if="$store.state.dataDesignation != null">
                                            <v-data-table 
                                                v-if="$store.state.dataDesignation != null"
                                                :headers="$store.state.ArticleFullHeaders"
                                                :items="this.$store.state.dataDesignation"
                                                color="blue lighten-2" 
                                                v-model="$store.state.designationSelectedArticle"
                                                :items-per-page="10"
                                                :single-select="true"
                                                item-key="EDI_Code"
                                                show-select
                                                class="elevation-1"
                                                v-on:input="loadArticleQuotations($store.state.designationSelectedArticle)"																
                                            ></v-data-table>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 v-if="$store.state.designationSelectedArticle !== null && $store.state.libelle !== '' && $store.state.libelle !== null && ($store.state.ArticleQuotations.length === null || $store.state.ArticleQuotations.length === 0)">
                                    <v-card-title v-if="$store.state.designationSelectedArticle !== null && $store.state.designationSelectedArticle.length > 0">
                                        <h5>Pas d'offre pour cet article</h5>
                                    </v-card-title>
                                </v-flex>
                                <v-flex xs12 v-if="$store.state.ArticleQuotations.length != null && $store.state.ArticleQuotations.length > 0">
                                    <v-btn v-if="$store.state.articleSelectedQuotationFileName != ''" class="ma-2" color="red" @click="quotationSelected($store.state.articleSelectedQuotationFileName)" dark>{{ $store.state.articleSelectedQuotationFileName }}
                                        <v-icon dark right>mdi-file-pdf</v-icon>
                                    </v-btn>
                                    <v-btn v-if="$store.state.articleSelectedQuotationNumber != ''" class="ma-2" color="blue"
                                        @click="quotationConvertLink($store.state.articleSelectedQuotationFileName)" dark>
                                        <v-icon left>mdi-file-swap</v-icon>
                                        {{ $store.state.articleSelectedQuotationFileName }} -> ASW
                                    </v-btn>
                                    <v-btn v-if="$store.state.articleSelectedQuotationNumber!=''" class="ma-2" color="green dark"
                                        @click="quotationXlsx($store.state.articleSelectedQuotationFileName)" dark>
                                        <v-icon left>mdi-file-swap</v-icon>
                                        {{ $store.state.articleSelectedQuotationFileName }} -> Excel
                                    </v-btn>
                                
                                    <v-card-title>
                                        <h5>Offres pour cet article :</h5>
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            v-model="$store.state.searchArticlesQuotations"
                                            append-icon="mdi-magnify"
                                            label="Recherche"
                                            single-line
                                            hide-details>
                                        </v-text-field>															
                                    </v-card-title>
                                    <v-data-table
                                        v-model="$store.state.selected"
                                        :headers="$store.state.ArticlesHeaders"
                                        :items="$store.state.ArticleQuotations"
                                        :items-per-page="10"
                                        :single-select="true"
                                        :search="$store.state.searchArticlesQuotations"
                                        item-key="ID"
                                        show-select
                                        class="elevation-1"
                                        v-on:input="articleSelected($store.state.selected)"
                                    >
                                        <template v-slot:item.QUOTATION_VALIDITY_DATE="{ item }">
                                            <v-chip :color="getColor(item.QUOTATION_VALIDITY_DATE)" dark>{{ item.QUOTATION_VALIDITY_DATE }}</v-chip>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text @click="rechercheMenu">Retour</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
	import axios from 'axios';

	export default {
		name: "RechercheParDesignation",

		data: function () {
			return {
				designationDialog: false,
				InfoDesignationHeaders: [
					{ text: 'Operator', value: 'OPERATOR' },
					{ text: 'Description', value: 'DESCRIPTION' },
					{ text: 'Example', value: 'EXAMPLE' },
				],
            }
        },
		methods: {
            rechercheMenu: function () {
                this.$store.state.VueRechercheMenu = true;
                this.$store.state.VueRechercheArticle = false;
                this.$store.state.VueRechercheDesignation = false;
                this.$store.state.VueRechercheOffre = false;
                this.$store.state.VueRechercheProjet = false;
            },
			loadArticleQuotations: function (selected) {
				if (selected.length) {
					this.$store.state.designationQuotations = true;
					var link = "http://domoserver.ddns.net/gigamedia1/loadArticleQuotations.php?edi_code=" + encodeURIComponent(selected[0].EDI_Code);
					axios.get(link).then(response => (this.$store.state.ArticleQuotations = response.data));
				}
				else {
					this.$store.state.designationQuotations = false;
				}
			},
			loadDesignationArticle: function (libelle, marque) {
				this.$store.state.designationSelectedArticle = null;
				this.$store.state.designationQuotations = false;
				this.$store.state.articleSelectedQuotationFileName = "";
				this.$store.state.articleSelectedQuotationNumber = "";
				var link = "http://domoserver.ddns.net/gigamedia1/loadDesignationData.php?libelle=" + encodeURIComponent(libelle) + "&marque=" + encodeURIComponent(marque);
				axios.get(link).then(response => (this.$store.state.dataDesignation = response.data));
			},
			getColor(dateValidation) {
				var dateValidationInt = new Date(dateValidation);
				var currentDate = new Date();
				if (dateValidationInt < currentDate)
					return "red";
				else
					return "green";
			},
			loadStockConectis: function (edi_code) {
				this.$store.state.stockConectis.QUANTITE = null;
				this.$store.state.stockConectis.REFERENCE_ASW = null;
				this.$store.state.stockConectis.REFERENCE_CONECTIS = null;
				this.$store.state.stockConectis.stock_ok = false;
				this.$store.state.stockConectis_is_loading = true;
				var link = "http://domoserver.ddns.net/gigamedia1/loadArticleData.php?edi_code=" + encodeURIComponent(edi_code);
				axios.get(link).then(response => (this.$store.state.dataArticle = response.data));
				link = "http://domoserver.ddns.net/gigamedia1/loadArticleQuotations.php?edi_code=" + encodeURIComponent(edi_code);
				axios.get(link).then(response => (this.$store.state.ArticleQuotations = response.data));
				link = "http://domoserver.ddns.net/gigamedia1/loadStockConectis.php?reference=" + encodeURIComponent(edi_code);
				axios.get(link).then(response => (this.$store.state.stockConectis = response.data,
					setTimeout(() => {
						this.$store.state.stockConectis_is_loading = false;
					}, 15000),
					this.$store.state.stockConectis_is_loading = !response.data.stock_ok));
			},
			articleSelected: function (selected) {
				if (selected.length) {
					this.$store.state.articleSelectedQuotationFileName = selected[0].QUOTATION_FILENAME;
					this.$store.state.articleSelectedQuotationNumber = selected[0].QUOTATION_NUMBER;
				}
			},
			quotationSelected: function (quotationFilename) {
				var pdf = "http://domoserver.ddns.net/gigamedia1/quotations/" + encodeURIComponent(quotationFilename) + ".pdf";
				window.open(pdf, "_blank");
			},
			quotationConvertLink: function (reference) {
				this.$store.state.quotationNumberToASW = reference;
				this.$store.state.quotationReference = reference;
				this.convertOk = false;
				var link = "http://domoserver.ddns.net/gigamedia1/loadQuotationByFileName.php?quotationFilename=" + encodeURIComponent(reference);
				axios.get(link).then(response => (this.$store.state.ConectisQuotation = response.data));
				this.$store.state.active = 1; //select convert tab
			},
			quotationXlsx: function (quotationFilename) {
				var quotationFilenameXlsx = quotationFilename + ".xlsx";
				var link = "http://domoserver.ddns.net/gigamedia1/XlsxWriter/quotationXlsx.php?quotationFileName=" + encodeURIComponent(quotationFilename);
				axios.get(link).then(response => {
					this.dataXlsx = response.data;
					var xlsx = "http://domoserver.ddns.net/gigamedia1/quotations/" + encodeURIComponent(quotationFilenameXlsx);
					window.open(xlsx, "window1", "");
				});
			},
        }
    }
</script>
